import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/adchieve.webp';
import screenshot_target from '../../../images/letterfunnel/markvanwerven.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Mark van Werven"
      firstname="Mark"
      companyname="Adchieve"
      competition="Skai en Marin"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/markvanwerven.js